import { Injectable } from "@angular/core";
import { UserService } from "../Authorization/UserService";
import { BrandingService } from "../Branding/BrandingService";
import { GlobalService } from "../GlobalService";
import { resolveCurrentTenant, DEFAULT_TENANT } from "../Branding/TenantResolver";
import "./appNavigation";

@Injectable()
export class AppNavigationService implements NP.External.IAppNavigationService {
    private navigator: AppNavigation;
    constructor(
        private userService: UserService,
        private brandingService: BrandingService,
        private globalService: GlobalService) {
    }

    initialise(): void {
        this.getConfigurationSuccess(this.brandingService.getSystemConfiguration());
    }

    getConfigurationSuccess(systemConfiguration: NPS.Common.Branding.ISystemConfiguration): void {
        if (systemConfiguration.AppNavigationEnabled) {
            const tenant = resolveCurrentTenant(this.globalService.location.host);
            const curredTenant = tenant in systemConfiguration.TenantSsoUrls ? tenant : DEFAULT_TENANT;
            const config: AppNavigationConfig = {
                ssoServerOrigin: systemConfiguration.TenantSsoUrls[curredTenant],
                appsServerOrigin: systemConfiguration.TenantAppNavigationUrls[curredTenant],
            };
            this.navigator = new AppNavigation(config);
            this.navigator.loadApplications(this.userService.user.token);
        }
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Extranet/AppNavigationService.ts